<template>
  <div id="app">
    <v-app>
      <!-- <v-btn fab class="ma-3" small absolute @click="drawer = !drawer" color="#d081d0" dark>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-navigation-drawer v-model="drawer" fixed temporary>
          <div class="logo-main pa-3 mt-2 mb-4">
            <router-link to="/">
              <v-img src="./assets/full-logo.png" alt="" />
            </router-link>
          </div>
        <v-list nav dense>
          <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
       
            
            <v-list-item to="/">
              <v-list-item-title>US Epidemic Explorer</v-list-item-title>
            </v-list-item>

            <v-list-item to="/us-travel">
              <v-list-item-title>US Travel Navigator</v-list-item-title>
            </v-list-item>

            <v-list-item to="/travel">
              <v-list-item-title>World Travel Navigator</v-list-item-title>
            </v-list-item>

            <v-list-item to="/africa">
              <v-list-item-title>Africa Epidemic Explorer</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer> -->
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
  },
  data: () => ({
    drawer: false,
    group: null,
  }),
};
</script>

<style lang="scss">
#app {
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  // margin-top: 60px;
  background: transparent;
}
</style>
